import { DaymapQuery as r } from "../daymapQuery.js";
var c;
((d) => {
  class i extends r {
    constructor(s) {
      super(
        ["details", s.studentId, s.formId, s.rowId],
        s,
        `/lms/api/payments/details?studentId=${s.studentId}&rowId=${s.rowId}&formId=${s.formId}`,
        null
      );
    }
  }
  d.PaymentAmountAndFees = i;
  class a extends r {
    constructor(s) {
      super(
        ["chargecard"],
        s,
        "/lms/api/payments/charge",
        null,
        {
          enabled: !1
        }
      );
    }
  }
  d.ChargeCard = a;
  class n extends r {
    constructor() {
      super(
        ["customer"],
        null,
        "/lms/api/payments/customer",
        null
      );
    }
  }
  d.Customer = n, ((e) => {
    e[e.None = 0] = "None", e[e.Due = 1] = "Due", e[e.Processing = 2] = "Processing", e[e.Failed = 3] = "Failed", e[e.Paid = 4] = "Paid", e[e.Refund = 5] = "Refund";
  })(d.PaymentStatusEnum || (d.PaymentStatusEnum = {}));
  class o extends r {
    constructor(s, l) {
      super(
        ["paymentsList", s, l],
        { from: s, to: l },
        `/lms/api/payments/list?from=${s == null ? void 0 : s.toJSON()}&to=${l == null ? void 0 : l.toJSON()}`,
        null,
        { stale: 1e3 * 60 * 10 }
        // 10 minutes
      );
    }
  }
  d.PaymentsList = o;
})(c || (c = {}));
export {
  c as payments
};
//# sourceMappingURL=index.js.map
